module.exports = fox._r("fonts/robotocondensed-regular-webfont.svg", __webpack_public_path__ + "_/_/_/root/fonts/robotocondensed-regular-webfont.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-regular-webfont.svg
// module id = 167
// module chunks = 4